import { object } from 'prop-types'
import { useContext } from 'react'
import { kuiperClassNames, renderIcon } from '@opallabs/kuiper'
import CardContext from '../../cardContext'
import { useWeekViewSettings } from '../../WeekViewSettingsContext'
import MomentDetails from '../MomentDetails'
import { TooltippedStoryHeading } from '../StoryHeading'
import AccessRequestPopover from './AccessRequestPopover'
import './styles.scss'

const PrivateMomentCard = ({ moment }) => {
  const currentUser = window.THIS_USER_DATA
  const { coverImageDisplay } = useWeekViewSettings()
  const { errors, onDismissError, requestAccess } =
    useContext(CardContext) ?? {}

  return (
    <div
      className={kuiperClassNames(
        'privateMomentCard',
        `privateMomentCard-${coverImageDisplay}`
      )}
    >
      <AccessRequestPopover
        entity={moment}
        errors={errors}
        me={currentUser}
        moment={moment}
        onDismissError={onDismissError}
        onRequestAccess={(message) => {
          requestAccess({
            message,
            privacyGroupId: moment.privacy_group.id,
          })
        }}
      >
        <MomentDetails moment={moment} classPrefix="privateMomentCard">
          <TooltippedStoryHeading moment={moment} />
        </MomentDetails>
        <div className={kuiperClassNames('privateMomentCard-privacyIcon')}>
          {renderIcon('private', {
            style: { height: 14, width: 14 },
            ariaLabel: 'This is a private moment',
            ariaMode: 'presentational',
          })}
        </div>
      </AccessRequestPopover>
    </div>
  )
}

PrivateMomentCard.propTypes = {
  moment: object,
}

export default PrivateMomentCard
